import React from "react";
import {
	WaBreadcrumb,
	WaBreadcrumbItem,
	WaButton,
	WaTooltip,
	WaDrawer,
	WaIcon,
} from "@web.awesome.me/webawesome-pro/dist/react";

import {
	IconDiaper,
	IconBabyBottle,
	IconMoonStars,
	IconRulerMeasure2,
	IconSparkles2,
	IconHeart,
	IconLayoutGrid,
	IconUserCircle,
	IconLogout,
} from "@tabler/icons-react";
import {useActiveChild} from "./ActiveChildContext";
import {auth} from "../firebase";
import {useNavigate} from "react-router-dom";

export const MainMenu = ({activePage}) => {
	const {activeChild} = useActiveChild();
	const navigate = useNavigate();

	return (
		<div>
			<WaButton
				className="btn-transparent btn-round icon-gloss"
				onClick={() => (document.getElementById("site-menu").open = true)}
			>
				<WaIcon
					family="default"
					name="bars"
					size={36}
				/>
			</WaButton>
			<WaDrawer
				id="site-menu"
				placement="end"
				className="has-bg"
			>
				<div className="column">
					<WaButton
						href="/"
						className={`align-start ${activePage === "timeline" ? "btn-accent" : "btn-transparent"}`}
					>
						<IconLayoutGrid
							size={24}
							slot="start"
						/>
						Home
					</WaButton>
					<WaButton
						href="/sleep-history"
						className={`align-start ${activePage === "sleep" ? "btn-accent" : "btn-transparent"}`}
						disabled
					>
						<IconMoonStars
							size={24}
							slot="start"
						/>
						Sleep
					</WaButton>
					<WaButton
						href="/diaper-history"
						className={`align-start ${activePage === "diapers" ? "btn-accent" : "btn-transparent"}`}
					>
						<IconDiaper
							size={24}
							slot="start"
						/>
						Diapers
					</WaButton>
					<WaButton
						href="/feed-history"
						className={`align-start ${activePage === "feed" ? "btn-accent" : "btn-transparent"}`}
					>
						<IconBabyBottle
							size={24}
							slot="start"
						/>
						Feedings
					</WaButton>
					<WaButton
						href="/growth-history"
						className={`align-start ${activePage === "growth" ? "btn-accent" : "btn-transparent"}`}
					>
						<IconRulerMeasure2
							size={24}
							slot="start"
						/>
						Growth
					</WaButton>
					<WaButton
						hidden="false"
						href="/milestone-history"
						className={`align-start ${activePage === "milestones" ? "btn-accent" : "btn-transparent"}`}
					>
						<IconSparkles2
							size={24}
							slot="start"
						/>
						Milestones
					</WaButton>
					<WaButton
						href="/health-history"
						className={`align-start ${activePage === "health" ? "btn-accent" : "btn-transparent"}`}
					>
						<IconHeart
							size={24}
							slot="start"
						/>
						Health
					</WaButton>
				</div>

				<WaButton
					href="/profile"
					className={`align-start full-width ${activePage === "profile" ? "btn-accent" : "btn-transparent"}`}
					slot="footer"
				>
					<IconUserCircle
						size={24}
						slot="start"
					/>
					Profile
				</WaButton>
				<WaButton
					onClick={() => {
						auth.signOut();
						navigate("/");
					}}
					className="align-start btn-transparent full-width"
					slot="footer"
				>
					<IconLogout
						size={24}
						slot="start"
					/>
					Logout
				</WaButton>
			</WaDrawer>
		</div>
	);
};
